<template>
  <div class="page-view">
    <template v-if="request">
      <header class="page-header">
        <h2 class="tit-h2">
          {{ request.customer.companyName}}
        </h2>
        <img
          v-for="(icon, index) in getFilteredIcons(request)"
          :key="index"
          :src="icon.src"
          :alt="icon.alt"
        />
        <status-tag
          :color="getTagColor(stat)"
          size="large"
          :text="getRequestStatusTypeValue(stat)"
        />
        <div class="btn-group">
          <el-button
            type="primary"
            size="large"
            @click="router.go(-1)"
          >
            <font-awesome-icon icon="fa-solid fa-arrow-left" />
            뒤로가기
          </el-button>
          <el-button
            v-if="isAuthorized"
            size="large"
            type="primary"
            class="btn-edit"
            @click="handleModifyRequest"
          >
            수정
          </el-button>
          <el-button
            v-if="isDeletable"
            size="large"
            type="primary"
            class="btn-edit"
            @click="handleDeleteRequest"
          >
            삭제
          </el-button>
          <el-button
            type="primary"
            size="large"
            @click="toCurrentPlanList"
            v-if="request.detail.requestType === 'PLAN'"
          >
            <font-awesome-icon icon="fa-solid fa-table-list" />
            플랜
          </el-button>
          <el-button
            type="primary"
            size="large"
            @click="toCurrentPaymentList"
          >
            <font-awesome-icon icon="fa-solid fa-table-list" />
            결제
          </el-button>
        </div>
      </header>
      <view-detail :data="request"/>
      <div 
        v-if="stat !== 'NON_ISSUE'"
        class="content-box task"
      >
        <h3 class="tit-h3">
          과업 수행
        </h3>        
        <el-form
          :model="form"
          label-position="left"
          label-width="100px"
          >
          <el-form-item
            label="플랜 생성 여부"
            v-show="stat === 'CREATED_REQUEST_PLAN'"
          >
            <el-radio-group v-model="form.isPlanCreated">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
            <div 
              v-if="form.isPlanCreated"
              class="screen"
              @paste="handlePaste"
            >
            <div class="img-area">
              <p 
                v-if="!form.attachedScreen"
                class="desc"
              >
                이미지를 클립보드에서 복사한 뒤 이 영역에 붙여넣어 주세요.
              </p>
              <img 
                v-if="form.attachedScreen"
                :src="form.attachedScreen" 
                alt="Pasted preview"
              />
            </div>
            <el-button
              v-if="form.attachedScreen"
              type="primary"
              text
              aria-label="삭제"
              @click="handleRemoveImage"
            >
              <font-awesome-icon icon="fa-regular fa-trash-can" />
            </el-button> 
          </div>
          <el-form-item
            label="PV 충전 여부"
            v-show="stat === 'CREATED_REQUEST_PV'"
          >
            <el-radio-group v-model="form.isPVCharged">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <div 
              v-if="form.isPVCharged"
              class="screen"
              @paste="handlePaste"
            >
            <div class="img-area">
              <p 
                v-if="!form.attachedScreen"
                class="desc"
              >
                이미지를 클립보드에서 복사한 뒤 이 영역에 붙여넣어 주세요.
              </p>
              <img 
                v-if="form.attachedScreen"
                :src="form.attachedScreen" 
                alt="Pasted preview"
              />
            </div>
            <el-button
              v-if="form.attachedScreen"
              type="primary"
              text
              aria-label="삭제"
              @click="handleRemoveImage"
            >
              <font-awesome-icon icon="fa-regular fa-trash-can" />
            </el-button> 
          </div>
          <el-form-item
            label="Jam 충전 여부"
            v-show="stat === 'CREATED_REQUEST_JAM'"
          >
            <el-radio-group v-model="form.isJamCharged">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <div 
              v-if="form.isJamCharged"
              class="screen"
              @paste="handlePaste"
            >
            <div class="img-area">
              <p 
                v-if="!form.attachedScreen"
                class="desc"
              >
                이미지를 클립보드에서 복사한 뒤 이 영역에 붙여넣어 주세요.
              </p>
              <img 
                v-if="form.attachedScreen"
                :src="form.attachedScreen" 
                alt="Pasted preview"
              />
            </div>
            <el-button
              v-if="form.attachedScreen"
              type="primary"
              text
              aria-label="삭제"
              @click="handleRemoveImage"
            >
              <font-awesome-icon icon="fa-regular fa-trash-can" />
            </el-button> 
          </div>
          <el-form-item
            :label="`부가서비스\n처리 여부`"
            v-show="stat === 'CREATED_REQUEST_ADDITIONAL'"
          >
            <el-radio-group v-model="form.isProcessedAdditionalService">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="입금 리마인드 메일 발송"
            v-show="stat === 'DAY_PAYMENT_WIRE_DELAY'"
          >
            <el-radio-group v-model="form.isSentRemindMail">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="입금 여부"
            v-show="stat === 'DAY_PAYMENT_WIRE' || stat === 'DAY_PAYMENT_WIRE_DELAY'"
          >
            <el-radio-group v-model="form.isComfirmedPaymentWire">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="입금일"
            v-show="form.isComfirmedPaymentWire"
          >
            <el-date-picker
              v-model="form.depositDate"
              type="date"
              placeholder="선택하세요"
              size="large"
              style="width: 150px"
              :clearable="false"
            />
          </el-form-item>
          <el-form-item
            label="카드 결제 여부"
            v-show="stat === 'DAY_PAYMENT_CARD'"
          >
            <el-radio-group v-model="form.isComfirmedPaymentCard">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <div 
              v-if="form.isComfirmedPaymentCard"
              class="screen"
              @paste="handlePaste"
            >
            <div class="img-area">
              <p 
                v-if="!form.attachedScreen"
                class="desc"
              >
                이미지를 클립보드에서 복사한 뒤 이 영역에 붙여넣어 주세요.
              </p>
              <img 
                v-if="form.attachedScreen"
                :src="form.attachedScreen" 
                alt="Pasted preview"
              />
            </div>
            <el-button
              v-if="form.attachedScreen"
              type="primary"
              text
              aria-label="삭제"
              @click="handleRemoveImage"
            >
              <font-awesome-icon icon="fa-regular fa-trash-can" />
            </el-button> 
          </div>
          <el-form-item
            label="세금계산서 발행 여부"
            v-show="stat === 'DAY_INVOICE_TAX'"
          >
            <el-radio-group v-model="form.isIssuedInvoiceTax">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="`${getDocumentTypeValue(request.state as DocumentTypeKeys)} 발행 여부`"
            v-show="stat === 'DAY_INVOICE'"
          >
            <el-radio-group v-model="form.isIssuedInvoices">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="연장 메일 발송 여부"
            v-show="stat === 'NEED_TO_EXTEND' && !request.detail.recurring"
          >
            <el-radio-group v-model="form.isSentMailExtended">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="답신 확인"
            v-show="stat === 'NEED_TO_EXTEND' && !request.detail.recurring"
          >
            <el-radio-group v-model="form.isConfirmedReply">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="신규 리퀘스트 생성 여부"
            v-show="stat === 'NEED_TO_EXTEND'"
          >
            <el-radio-group v-model="form.isCreatedNewRequest">
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="플랜 연장 미진행"
            v-show="stat === 'NEED_TO_EXTEND' && !request.detail.recurring"
          >
            <el-radio-group 
              v-model="form.isPlanNotExtended"
              :disabled="!isPlanNotExtendedEnabled"
            >
              <el-radio :value="true">
                예
              </el-radio>
              <el-radio :value="false">
                아니오
              </el-radio>
            </el-radio-group>
          </el-form-item>


        </el-form>
        <div class="btn-group">
          <el-button
            type="primary"
            size="large"
            :disabled="!isModified || uploadLoading"
            @click="handleSubmit"
          >
            과업 저장
          </el-button>
          <el-button
            type="default"
            size="large"
            @click="handleCancel"
          >
            취소
          </el-button>
        </div>
      </div>
      <section class="section">
        <h3 class="tit-h3">
          히스토리
        </h3>
        <history-list
          :data="request"
          @open-image-viewer="openImageViewer"
        />
      </section>
    </template>
    <common-loader v-else />
  </div>
  <history-image-viewer
    v-if="showImageViewer"
    :url="currentImage"
    @close="closeImageViewer"
  />
</template>

<script lang="ts" setup>
import {ref, defineProps, reactive, computed, onMounted, watch, type Ref } from "vue";
import { useRouter } from "vue-router";
import { useRequestStore } from "@/stores/request";
import { RequestTypeKeys, RequestStatusKeys, DocumentTypeKeys } from "@/types/constants";
import { FormTask } from '@/types/Form';
import { RequestInfo } from '@/types/Request';
import { getRequestInfo, uploadImagetoServer, updateTask, removeRequest, modifyRequest } from "@/api";
import { disablePastDates, getTagColor} from "@/utils";
import { getRequestStatusTypeValue, getDocumentTypeValue }  from '@/utils/getValueForKey';
import { ElMessageBox, ElNotification, ElMessage } from 'element-plus';
import moment from 'moment-timezone';
import CommonLoader from '@/components/CommonLoader.vue';
import ViewDetail from "@/components/ViewDetail.vue";
import HistoryList from '@/components/HistoryList.vue';
import HistoryImageViewer from "@/components/HistoryImageViewer.vue";
import StatusTag from '@/components/StatusTag.vue';
import IconBeus from '@/assets/images/ico-beus.svg';

import IconBi from '@/assets/images/ico-bi.svg';
import IconPV from '@/assets/images/ico-pv.svg';
import IconJam from '@/assets/images/ico-jam.svg';
import IconService from '@/assets/images/ico-service.svg';
import {useAuthorizedUsers} from "@/composables/useAuthorizedUsers";

const router = useRouter();
const requestStore = useRequestStore();
const { isAuthorized } = useAuthorizedUsers()
const request = ref<RequestInfo | null>(null);
const isLoading = ref<boolean>(false);

const props = defineProps<{
  id: string;
  stat: RequestStatusKeys;
}>();

const fetchData = async (id: string) => {
  isLoading.value = true;
  const params = {
    requestId: id,
    ...(props.stat !== "NON_ISSUE" && { subId: requestStore.subId })
  }

  try {
    const response = await getRequestInfo(params);
    // console.log('Reqeust Info', response.result);

    if(response.result) {
      const { state } = response.result;
      const normalizedState = state ? state.trim().toUpperCase() : '';
      const normalizedPropsStat = props.stat ? props.stat.trim().toUpperCase() : '';

      // console.log(normalizedState, normalizedPropsStat);
      
      const specialCaseMap = {
        'TAX_INVOICE': ['DAY_INVOICE_TAX'],
        'QUOTATION': ['DAY_INVOICE'],
        'CONTRACT': ['DAY_INVOICE'],
        'INVOICE': ['DAY_INVOICE'],
        'TRANSACTION': ['DAY_INVOICE'],
        'SETTLEMENT': ['DAY_INVOICE']
      };
      
      const isMatching = normalizedState === normalizedPropsStat || 
        (specialCaseMap[normalizedState as keyof typeof specialCaseMap] && 
        specialCaseMap[normalizedState as keyof typeof specialCaseMap].includes(normalizedPropsStat));
      
      
      if (isMatching) {
        request.value = response.result;
        requestStore.setRequestData(response.result);
      } else {
        await ElMessageBox.alert('데이터를 가져올 수 없습니다. 대시보드로 이동합니다.', {
          confirmButtonText: '확인',
          callback: () => {
            router.push('/request');
          },
        });
      }
    }
  } catch (error) {
    console.error('Error Message:', error);
    ElMessageBox.alert('데이터를 가져올 수 없습니다. 대시보드로 이동합니다.', {
      confirmButtonText: '확인',
      callback: () => {
        router.push("/request");
      },
    });
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchData(props.id);
});

interface RequestDetailCondition {
  requestType: RequestTypeKeys;
  beusPlanNumber: number | null;
  baPlanNumber: number | null;
}

interface Icon {
  condition: (detail: RequestDetailCondition) => boolean;
  src: string;
  alt: string;
}

const icons: Icon[] = [
  {
    condition: ({ requestType, beusPlanNumber }: RequestDetailCondition) => 
      requestType === 'PLAN' && !!beusPlanNumber,
    src: IconBeus,
    alt: '플랜-히트맵',
  },
  {
    condition: ({ requestType, baPlanNumber }: RequestDetailCondition) => 
      requestType === 'PLAN' && !!baPlanNumber,
    src: IconBi,
    alt: '플랜-저니맵',
  },
  {
    condition: ({ requestType }: RequestDetailCondition) => 
      requestType === 'PV_CHARGE',
    src: IconPV,
    alt: 'PV 충전',
  },
  {
    condition: ({ requestType }: RequestDetailCondition) => 
      requestType === 'JAM_CHARGE',
    src: IconJam,
    alt: 'JAM 충전',
  },
  {
    condition: ({ requestType }: RequestDetailCondition) => 
      requestType === 'ADDITIONAL',
    src: IconService,
    alt: '부가서비스',
  },
];

const getFilteredIcons = (request: RequestInfo): Icon[] => {
  const detail = {
    requestType: request.detail.requestType,
    baPlanNumber: request.detail.baPlanNumber,
    beusPlanNumber: request.detail.beusPlanNumber
  }
  return icons.filter((icon) => icon.condition(detail));
};

const form: FormTask = reactive({
  isPlanCreated: false,
  attachedPlanScreen: null,
  isPVCharged: false,
  attachedPVScreen: null,
  isJamCharged: false,
  attachedJamScreen: null,
  isProcessedAdditionalService: false,
  isComfirmedPaymentWire: props.stat === 'DAY_PAYMENT_WIRE_DELAY' ? !!request.value?.tasks.CONFIRMED_PAYMENT_WIRE : false,
  depositDate : null,
  isComfirmedPaymentCard: false,
  isSentRemindMail: props.stat === 'DAY_PAYMENT_WIRE_DELAY' ? !!request.value?.tasks.SENT_REMIND_MAIL : false,
  attachedPaymentScreen: null,
  isIssuedInvoiceTax: false ,
  isIssuedInvoices: [false],
  isSentMailExtended: props.stat === 'NEED_TO_EXTEND' ? !!request.value?.tasks.SENT_MAIL_EXTEND : false,
  isConfirmedReply: props.stat === 'NEED_TO_EXTEND' ? !!request.value?.tasks.CONFIRMED_REPLY : false,
  isCreatedNewRequest: props.stat === 'NEED_TO_EXTEND' ? !!request.value?.tasks.CREATED_NEW_REQUEST : false,
  attachedScreen: null,
  isPlanNotExtended: false
});

const originalForm = ref<FormTask>(structuredClone(form));
// console.log('first', originalForm);

watch(request, (newRequest) => {
  if (!newRequest) return;

  form.isComfirmedPaymentWire = props.stat === 'DAY_PAYMENT_WIRE_DELAY' ? !!newRequest.tasks.CONFIRMED_PAYMENT_WIRE : false;
  form.isSentRemindMail = props.stat === 'DAY_PAYMENT_WIRE_DELAY' ? !!newRequest.tasks.SENT_REMIND_MAIL : false;
  form.isSentMailExtended = props.stat === 'NEED_TO_EXTEND' ? !!newRequest.tasks.SENT_MAIL_EXTEND : false;
  form.isConfirmedReply = props.stat === 'NEED_TO_EXTEND' ? !!newRequest.tasks.CONFIRMED_REPLY : false;
  form.isCreatedNewRequest = props.stat === 'NEED_TO_EXTEND' ? !!newRequest.tasks.CREATED_NEW_REQUEST : false;
  form.isPlanNotExtended = props.stat === 'NEED_TO_EXTEND' ? !!newRequest.tasks.DONT_NEED_TO_EXTEND : false;

  originalForm.value = structuredClone(form);
  // console.log('second', originalForm);
}, { deep: true });

// 플랜 연장 미진행 조건 변경 감지
watch([() => form.isSentMailExtended, () => form.isConfirmedReply, () => form.isCreatedNewRequest], () => {
  if (!isPlanNotExtendedEnabled.value && form.isPlanNotExtended) {
    form.isPlanNotExtended = false;
  }
});

const uploadLoading = ref<boolean>(false)

const isModified = computed(() => {
  return JSON.stringify(form) !== JSON.stringify(originalForm.value);
});

const isPlanNotExtendedEnabled = computed(() => {
  return form.isSentMailExtended && form.isConfirmedReply && !form.isCreatedNewRequest;
});

const selectedFile = ref<File | null>(null);

const handlePaste = (event: ClipboardEvent) => {
  const items = event.clipboardData?.items;
  if (!items) {
    ElNotification({
      title: '오류',
      message: '클립보드 데이터를 읽을 수 없습니다.',
      type: 'error',
    });
    return;
  }

  for (const item of items) {
    if (item.type.startsWith('image/')) {
      selectedFile.value = item.getAsFile();
      if (selectedFile.value) {
        form.attachedScreen = URL.createObjectURL(selectedFile.value);
        ElNotification({
          title: '성공',
          message: '이미지를 성공적으로 붙여넣었습니다.',
          type: 'success',
        });
      } else {
        ElNotification({
          title: '오류',
          message: '이미지를 처리하는 데 실패했습니다.',
          type: 'error',
        });
      }
      return;
    }
  }
  ElNotification({
    title: '오류',
    message: '붙여넣은 데이터에서 이미지를 찾을 수 없습니다.',
    type: 'warning',
  });
};

const handleRemoveImage = () => {
  Object.assign(form, { attachedScreen: null });
}

const uploadImage = async () => {
  console.log('Upalod Image...')
  if (!selectedFile.value) {
    console.error('No Image!');
    ElMessage.error('이미지를 찾을 수 없습니다.');
    return false;
  }

  const formData = new FormData();
  const newFileName = `${requestStore.requestId}_${props.stat.toLowerCase()}_${moment().format('YYYYMMDDHHmmss')}.png`
  formData.append('image', selectedFile.value, newFileName);
  // formData.forEach((value, key) => {
  //   console.log(key, value);
  // });

  try {
    const response = await uploadImagetoServer(formData);
    // console.log(`Upload successful!: ${response.result}`);
    if (response.result) {
      return response.result;
    } else return null;
  } catch (error) {
    console.error('Upload failed:', error);
    ElMessage.error('이미지를 업로드하는데 실패했습니다. 다시 시도해주세요.');
    return null;
  }
};

const handleSubmit = async () => {
  if (uploadLoading.value) return
  uploadLoading.value = true
  let fileName = null;

  if(form.isPlanCreated || form.isPVCharged || form.isJamCharged || form.isComfirmedPaymentCard) {
    try {
      fileName = await uploadImage();
    } catch (error) {
      console.error('이미지 업로드 실패:', error);
      uploadLoading.value = false
      return;
    }

    if (!fileName) {
      ElMessageBox.alert('스크린 캡쳐는 필수입니다.', {
        confirmButtonText: '확인',
      });
      uploadLoading.value = false
      return;
    }
    
  } else fileName = null;

  if(form.isComfirmedPaymentWire) {
    if (!form.depositDate) {
      ElMessageBox.alert('입금일 지정은 필수입니다.', {
        confirmButtonText: '확인',
      });
      return;
    }
  }

  if(!request.value?.detail.recurring) {
    if((form.isSentMailExtended === false && form.isConfirmedReply) || (form.isSentMailExtended === false && form.isCreatedNewRequest)) {
      ElMessageBox.alert('연장 메일 발송이 먼저 수행되어야 합니다.', {
        confirmButtonText: '확인',
      });
      return;
    }

    if((form.isConfirmedReply === false && form.isCreatedNewRequest)) {
      ElMessageBox.alert('답신 확인 후 리퀘스트 생성이 수행되어야 합니다.', {
        confirmButtonText: '확인',
      });
      return;
    }
  }

  const taskMappings: Record<string, any> = {
    CREATED_REQUEST_PLAN: {
      CREATED_EAGLE_PLAN: form.isPlanCreated,
      ATTACHED_PLAN_SCREEN: fileName
    },
    CREATED_REQUEST_PV: {
      CHARGED_EAGLE_PV: form.isPVCharged,
      ATTACHED_PV_SCREEN: fileName
    },
    CREATED_REQUEST_JAM: {
      CHARGED_EAGLE_JAM: form.isJamCharged,
      ATTACHED_JAM_SCREEN: fileName
    },
    CREATED_REQUEST_ADDITIONAL: {
      PROCESSED_ADDITIONAL_SERVICE: form.isProcessedAdditionalService
    },
    DAY_PAYMENT_WIRE: {
      CONFIRMED_PAYMENT_WIRE: form.isComfirmedPaymentWire,
      DATE_PAYMENT_WIRE: moment(form.depositDate).format('YYYY-MM-DD')
    },
    DAY_PAYMENT_WIRE_DELAY: {
      SENT_REMIND_MAIL: form.isSentRemindMail,
      CONFIRMED_PAYMENT_WIRE: form.isComfirmedPaymentWire,
      DATE_PAYMENT_WIRE: moment(form.depositDate).format('YYYY-MM-DD')
    },
    DAY_PAYMENT_CARD: {
      CONFIRMED_PAYMENT_CARD: form.isComfirmedPaymentCard,
      ATTACHED_PAYMENT_SCREEN: fileName
    },
    DAY_INVOICE_TAX: {
      ISSUED_INVOICE_TAX: form.isIssuedInvoiceTax
    },
    DAY_INVOICE: {
      ISSUED_INVOICE: form.isIssuedInvoices
    },
    NEED_TO_EXTEND: (request: Ref<RequestInfo | null>) => {
      if (request.value?.detail.recurring) {
        return {
          CREATED_NEW_REQUEST: form.isCreatedNewRequest
        };
      } else {
        return {
          SENT_MAIL_EXTEND: form.isSentMailExtended,
          CONFIRMED_REPLY: form.isConfirmedReply,
          CREATED_NEW_REQUEST: form.isCreatedNewRequest,
          DONT_NEED_TO_EXTEND: form.isPlanNotExtended
        };
      }
  },
    NON_ISSUE: {},
    COMPLETED_REQUEST: {}
  };
  const updatedTasks =
  typeof taskMappings[props.stat] === "function"
    ? taskMappings[props.stat](request)
    : taskMappings[props.stat] || {};

  const formData = {
    requestId: requestStore.requestId,
    subId: requestStore.subId,
    tasks: updatedTasks
  }
  try {
    console.log('formData', formData)
    console.log('requestStore.requestId:', requestStore.requestId)
    console.log('requestStore.subId:', requestStore.subId)
    
    const response = await updateTask(formData);
    console.log('과업 성공:', response);
    
    // 응답 구조 확인
    if (response && (response.success || response.result)) {
      ElMessageBox.alert('과업을 저장했습니다. 보드로 이동합니다', {
        confirmButtonText: '확인',
        callback: () => {
          router.push("/request");
        },
      });
    } else {
      console.error('응답 구조 문제:', response);
      ElMessage.error('과업 저장에 실패했습니다. 다시 시도해주세요')
    }
  }
  catch (error) {
    console.error('Error message:', error)
    console.error('Error details:', error instanceof Error ? error.message : String(error))
    ElMessage.error('과업 저장에 실패했습니다. 다시 시도해주세요')
  } finally {
    uploadLoading.value = false
  }
}

const handleCancel = () => {
  ElMessageBox.confirm(
    '과업을 저장하지 않고 보드로 이동합니다', {
      confirmButtonText: '확인',
      cancelButtonText: '취소',
    })
    .then(() => { router.push("/request"); })
    .catch(() => { return false; })
}

const showImageViewer = ref(false);
const currentImage = ref('');
const openImageViewer = (url = '') => {
  currentImage.value = url;
  showImageViewer.value = true;
};
const closeImageViewer = () => {
  showImageViewer.value = false;
};

const requiredLogTypes = [
  'CREATED_EAGLE_PLAN',
  'CREATED_EAGLE_PV',
  'CREATED_EAGLE_JAM',
  'PROCESSED_REQUEST_ADDITIONAL',
];

const isModifiable = computed(() => {
  const hasRequiredLog = requiredLogTypes.some((logType) => {
    const exists = request.value?.history.some((item) => item.logType === logType);
    return exists;
  });

  if (!hasRequiredLog) {
    return true;
  }

  const isBeforeToday = request.value ? new Date(request.value.detail.useStartDate) > new Date() : false;

  if(request.value?.history.some((item) => item.logType === 'CREATED_EAGLE_PLAN')) return isBeforeToday;
  else return false;
});

const handleModifyRequest = () => router.push(`/request/modify/${props.id}`);

const isDeletable = computed(() => {
  const hasRequiredLog = requiredLogTypes.some((logType) => {
    const exists = request.value?.history.some((item) => item.logType === logType);
    return exists;
  });

  if (!hasRequiredLog) {
    return true;
  }

  const isBeforeToday = request.value ? new Date(request.value.detail.useStartDate) > new Date() : false;
  return isBeforeToday;
});

const handleDeleteRequest = async () => {
  try {
    await ElMessageBox.confirm(
      '리퀘스트를 정말 삭제하시겠습니까?<br/>삭제한 리퀘스트는 복구할 수 없습니다.',
      '경고',
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      }
    );
    
    const params = { requestId: props.id }
    const response = await removeRequest(params);

    if(response.success) {
      ElMessage({
        message: '삭제가 완료되었습니다.',
        type: 'success',
      });
      router.push({name: 'Board'});
    }

  } catch (error) {
    if (error === 'cancel') {
      return;
    }
    console.error('Error messege:', error);
    ElMessage({
      message: '삭제 중 오류가 발생했습니다.',
      type: 'error',
    });
  }
}
const toCurrentPlanList = () => router.push({ path: '/request/plan', query: { param: request.value?.customer.customerId } });
const toCurrentPaymentList = () => router.push({ path: '/request/payment', query: { param: request.value?.customer.customerId } });
</script>